import { fetcher } from '@commenda/utils';

export async function setCompanyAffiliateFirm(
  companyId: number,
  affiliateFirmId: string | null
) {
  const res = await fetcher(`affiliate-firms/by-company/${companyId}`, {
    method: 'PUT',
    body: { affiliateFirmId },
  });

  if (!res.ok) throw new Error('Failed to update company affiliate firm');
}
